// removed by extract-text-webpack-plugin
module.exports = {"red":"red__1awQ8","gray":"gray__szUkm","white":"white__KTgOm","checkbox":"checkbox__NGtOB"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/DeviceModal/styles.scss
// module id = 828
// module chunks = 1